<template>
  <v-btn-form :title="title" @close="$emit('close')">
      <slot></slot>
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'info-form',
    components: {vBtnForm},
    data: () => ({
    }),
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    created () {
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        fullscreen: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      })
    },
    methods: {
    }
  }

</script>




// WEBPACK FOOTER //
// InfoForm.vue?44545a50